export function getHeight() {
  return document.getElementsByClassName('course_leaderboard_table')[0].clientHeight
}
